import { Input } from './input'
import { X } from 'lucide-react'
import { cn } from '@/lib/utils'

interface InputWithClearProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onClear?: () => void
  showClear?: boolean
}

export function InputWithClear({
  className,
  value,
  onClear,
  showClear = true,
  ...props
}: InputWithClearProps) {
  const hasValue = value !== undefined && value !== ''

  return (
    <div className="relative w-full">
      <Input
        value={value}
        className={cn('pr-8', className)}
        {...props}
      />
      {showClear && hasValue && onClear && (
        <button
          type="button"
          onClick={onClear}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X size={14} />
        </button>
      )}
    </div>
  )
}
